/**
 * Texts for FAQs page
 */
export const faqPageText = {
    title: 'Vanlige spørsmål – CamAPS FX',
    titleMeta: 'Har du et spørsmål om CamAPS FX?',
    descriptionMeta: 'Her er svarene på noen vanlige spørsmål om kompatible enheter, godkjenning fra myndighetene, tilgjengelighet og klinisk forskning',
    keywords:
        'camaps faqs, camaps fx faqs, ',
        // 'type 1 diabetes, autoimmune disease, hyperglycemia, dexcom g6, type 1 diabetes symptoms, blood sugar monitor, diasend, insulin pump, diabetes type 1, blood glucose monitor, blood sugar, cgm, high blood sugar, type 1 diabetes causes, what is type 1 diabetes, diabetes in children, type 1, diabetes treatment, type 1 diabetes treatment, what is hypoglycemia, hypoglycemia treatment, jdrf, blood glucose meters, glucose monitor, type one diabetes, continuous glucose monitoring, type 1 diabetes in children, diabetes pump, t1d, closed loop system, diabetes machine, diabetic gastroparesis, diabetic hypoglycemia, diasend uk, diabetes 1, blood glucose monitor boots,  ',
    localeMeta: 'nb_no',

    haveQuestion: 'Har du et spørsmål om CamAPS FX?',
    hereAnswers: 'Her er svarene på noen vanlige spørsmål.',
    whatIsCamAPS: 'Hva er CamAPS FX?',
    whatIsCamAPSAnswer: 'CamAPS FX er en avansert, brukervennlig app for styring av glukoseverdier hos personer med diabetes type 1, som er 1 år eller eldre, ved hjelp av en avansert hybrid closed loop-løsning.',
    isApproved: 'Er CamAPS FX godkjent for bruk?',
    isApprovedAnswer: 'Appen har blitt grundig testet i kliniske studier og er godkjent for bruk i en rekke land og regioner, inkludert Australia, Canada, Den europeiske union, New Zealand, Norge, Sveits, Storbritannia og USA.',
    isAvailable: 'Er CamAPS FX tilgjengelig der jeg bor?',
    isAvailableAnswer1: 'CamAPS FX er tilgjengelig ved utvalgte diabetesklinikker eller for personer som betaler pleien sin selv og gjennomgår nettbasert opplæring. Spør der du får behandling, eller gå til',
    isAvailableAnswer2: 'Bestilling',
    isAvailableAnswer3: 'for å bestille appen.',
    whatIsLiberty: 'Hva er CamAPS Liberty?',
    whatIsLibertyAnswer: 'CamAPS Liberty er en funksjon i CamAPS FX. Når den er aktivert, trenger brukerne ikke å telle karbohydrater eller gi bolus før måltider og mellommåltider.',
    whatIsLibertyMoreInfo1: 'Du finner mer informasjon på ',
    whatIsLibertyPageLink: 'CamAPS Liberty-siden',
    whatIsLibertyMoreInfo2: ' vår, eller du kan laste ned dette ',
    whatIsLibertyFactsheetLink: 'faktaarket',
    whatIsLibertyMoreInfo3: '.',
    whatIsLibertyFactsheetUrl: '#',
    cost: 'Hvor mye koster CamAPS FX?',
    costAnswer1: 'Du finner informasjon om priser på',
    costAnswer2: 'på nettstedet vårt.',
    compatibleCgm: 'Hvilke CGM-enheter er kompatible med CamAPS FX?',
    compatibleCgmBody: 'CamAPS FX er kompatibelt med Dexcom G6, Dexcom G7, FreeStyle Libre 3 og FreeStyle Libre 3 Plus. Klikk på lenkene for å se hvilke smarttelefoner og operativsystemer som er kompatible.',
    whatPumps: 'Hvilke insulinpumper er kompatible med CamAPS FX?',
    whatPumpsAnswer1: 'CamAPS FX er kompatibel med YpsoPump-insulinpumper på Google Play og Apple App Store.',
    whatPumpsAnswer2: '',
    whatPumpsAnswer3: '',
    whatPumpsAnswerHtml: 'https://advancedtherapeutics.org.uk/shop/dana-diabecare-insulin-pump/dana-i-insulin-pump',
    whatPhone: 'Hvilke smarttelefoner er kompatible med CamAPS FX?',
    whatPhoneAnswer: 'Smarttelefonen din må være kompatibel med det CGM-systemet du bruker.',
    cgmManufacturerListText: 'Sjekk kompatibilitetslisten fra produsenten av CGM-systemet ditt for Dexcom G6, Dexcom G7, FreeStyle Libre 3 eller FreeStyle Libre 3 Plus.',
    whatOperating: 'Hvilke operativsystemer er kompatible med CamAPS FX?',
    whatOperatingAnswer: 'CamAPS FX støtter Android 13 til 16 og iOS 18 til 27, inkludert påfølgende mindre oppdateringer. Operativsystemet ditt må også være kompatibelt med det CGM-systemet du bruker.',
    whatOperatingManufacturerText: 'Sjekk kompatibilitetslisten til produsenten av CGM-systemet ditt for Dexcom G6, Dexcom G7, FreeStyle Libre 3 eller FreeStyle Libre 3 Plus.',
    whatPhoneAnswerDexcomHtml:'https://www.dexcom.com/en-GB/compatibility/g6',
    whatPhoneAnswerDexcomG7Html:'https://www.dexcom.com/en-GB/compatibility/g7',
    whatPhoneAnswerLibreHtml:'https://freestyleserver.com/Payloads/IFU/2026/q2/ART43193-006_rev-AP-pub.pdf',

    whereUpload: 'Hvor kan jeg laste opp dataene mine fra CamAPS FX?',
    whereUploadAnswer: 'For øyeblikket kan data fra CamAPS FX lastes opp til mylife Cloud og Glooko.',
    whatLanguage: 'Hvilke språk er tilgjengelige i CamAPS FX?',
    whatLanguageAnswer: 'CamAPS FX er tilgjengelig på engelsk, tsjekkisk, dansk, nederlandsk, fransk, finsk, tysk, italiensk, norsk, polsk, spansk og svensk.',
    whereResults: 'Hvor finner jeg resultatene fra de kliniske forsøkene deres?',
    whereResultsAnswer1: 'Publikasjoner knyttet til bruken av Cambridge-kontrollalgoritmen er tilgjengelig for nedlasting',
    whereResultsAnswer2: 'her.',
    whereResultsAnswer3: 'Viktige publikasjoner ble offentliggjort i',
    whereResultsAnswer4: 'og',

    wantMoreInfoIOS: 'Vil du vite mer om CamAPS FX-appen for iOS?',
    wantMoreInfoIOSanswer1: '',
    wantMoreInfoIOSanswer2: 'Klikk her',
    wantMoreInfoIOSanswer3: 'for å lese mer.',
    wantMoreInfoIOSanswerHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/iOS+FAQ_NO_005.pdf',

    wantMoreInfoCGManswerHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/Sensor_FAQs_NO.pdf',
};
